/* ==========================================================================
   KOYO.CL — comportamiento propio. Sin librerias externas.
   Cada init comprueba que su elemento existe, asi el mismo archivo
   sirve para todas las paginas.
   ========================================================================== */
(function () {
  'use strict';

  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Entradas al hacer scroll (un solo observador compartido) ----------- */
  function initReveals() {
    var elementos = document.querySelectorAll('.ky-reveal:not(.ky-visible)');
    if (!elementos.length) return;

    if (sinMovimiento || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('ky-visible'); });
      return;
    }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        var el = entrada.target;
        var retardo = parseInt(el.dataset.kyRetardo || '0', 10);
        setTimeout(function () { el.classList.add('ky-visible'); }, retardo);
        observador.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    elementos.forEach(function (el) { observador.observe(el); });
  }

  /* --- Cifras que cuentan hacia arriba ------------------------------------ */
  function initContadores() {
    var contadores = document.querySelectorAll('[data-ky-contador]');
    if (!contadores.length) return;

    if (sinMovimiento || !('IntersectionObserver' in window)) {
      contadores.forEach(function (el) { el.textContent = el.dataset.kyContador; });
      return;
    }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        var el = entrada.target;
        observador.unobserve(el);
        var destino = parseInt(el.dataset.kyContador, 10);
        if (isNaN(destino)) { return; }
        var inicio = null;
        var duracion = 1100;
        function paso(ahora) {
          if (inicio === null) inicio = ahora;
          var avance = Math.min((ahora - inicio) / duracion, 1);
          var suave = 1 - Math.pow(1 - avance, 3);
          el.textContent = Math.round(destino * suave);
          if (avance < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.5 });

    contadores.forEach(function (el) { observador.observe(el); });
  }

  /* --- Acordeones de la pagina de producto -------------------------------- */
  function initAcordeones() {
    var acordeones = document.querySelectorAll('.ky-acordeon');
    if (!acordeones.length) return;

    acordeones.forEach(function (acordeon) {
      var boton = acordeon.querySelector('.ky-acordeon__btn');
      if (!boton || boton.dataset.kyListo === '1') return;
      boton.dataset.kyListo = '1';
      boton.addEventListener('click', function () {
        var abierto = acordeon.classList.toggle('ky-abierto');
        boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  /* --- Galeria de la pagina de producto ----------------------------------- */
  function initGaleria() {
    var galerias = document.querySelectorAll('[data-ky-galeria]');
    if (!galerias.length) return;

    galerias.forEach(function (galeria) {
      if (galeria.dataset.kyListo === '1') return;
      galeria.dataset.kyListo = '1';

      var principal = galeria.querySelector('[data-ky-galeria-principal]');
      var minis = galeria.querySelectorAll('[data-ky-galeria-mini]');
      if (!principal || !minis.length) return;

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.dataset.kyGaleriaMini;
          if (!src) return;
          principal.src = src;
          minis.forEach(function (otra) { otra.classList.remove('ky-activa'); });
          mini.classList.add('ky-activa');
        });
      });
    });
  }

  /* --- Selector de variantes ---------------------------------------------- */
  function initVariantes() {
    var formularios = document.querySelectorAll('[data-ky-form-producto]');
    if (!formularios.length) return;

    formularios.forEach(function (form) {
      if (form.dataset.kyListo === '1') return;
      form.dataset.kyListo = '1';

      var radios = form.querySelectorAll('input[name="id"]');
      var salidaPrecio = form.querySelector('[data-ky-precio-activo]');
      if (!radios.length) return;

      function refrescar() {
        radios.forEach(function (radio) {
          var fila = radio.closest('.ky-variante');
          if (fila) fila.classList.toggle('ky-seleccionada', radio.checked);
          if (radio.checked && salidaPrecio && radio.dataset.kyPrecio) {
            salidaPrecio.textContent = radio.dataset.kyPrecio;
          }
        });
      }

      radios.forEach(function (radio) { radio.addEventListener('change', refrescar); });
      refrescar();
    });
  }

  /* --- Comparador antes / después ----------------------------------------- */
  function initComparador() {
    var comparadores = document.querySelectorAll('[data-ky-comparador]');
    if (!comparadores.length) return;

    comparadores.forEach(function (caja) {
      if (caja.dataset.kyListo === '1') return;
      caja.dataset.kyListo = '1';

      var recorte = caja.querySelector('[data-ky-comparador-recorte]');
      var asa = caja.querySelector('[data-ky-comparador-asa]');
      if (!recorte || !asa) return;

      var arrastrando = false;

      function poner(porcentaje) {
        var p = Math.max(0, Math.min(100, porcentaje));
        recorte.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
        asa.style.left = p + '%';
        asa.setAttribute('aria-valuenow', Math.round(p));
      }

      function desdeEvento(e) {
        var caja_ = caja.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - caja_.left;
        poner((x / caja_.width) * 100);
      }

      asa.addEventListener('mousedown', function (e) { arrastrando = true; e.preventDefault(); });
      asa.addEventListener('touchstart', function () { arrastrando = true; }, { passive: true });
      window.addEventListener('mouseup', function () { arrastrando = false; });
      window.addEventListener('touchend', function () { arrastrando = false; });
      window.addEventListener('mousemove', function (e) { if (arrastrando) desdeEvento(e); });
      window.addEventListener('touchmove', function (e) { if (arrastrando) desdeEvento(e); }, { passive: true });
      caja.addEventListener('click', function (e) {
        if (e.target === asa || asa.contains(e.target)) return;
        desdeEvento(e);
      });

      /* Accesible con el teclado */
      asa.addEventListener('keydown', function (e) {
        var actual = parseFloat(asa.getAttribute('aria-valuenow') || '50');
        if (e.key === 'ArrowLeft') { poner(actual - 4); e.preventDefault(); }
        if (e.key === 'ArrowRight') { poner(actual + 4); e.preventDefault(); }
      });

      poner(parseFloat(caja.dataset.kyComparador) || 50);
    });
  }

  /* --- Barra de compra que aparece al bajar -------------------------------- */
  function initBarraCompra() {
    var barra = document.querySelector('[data-ky-barra]');
    if (!barra || barra.dataset.kyListo === '1') return;
    barra.dataset.kyListo = '1';

    var disparador = document.querySelector('[data-ky-barra-disparador]')
      || document.querySelector('.ky-hero, .ky-producto');

    function revisar() {
      var mostrar;
      if (disparador) {
        mostrar = disparador.getBoundingClientRect().bottom < 0;
      } else {
        mostrar = window.scrollY > 700;
      }
      /* Se esconde al final para no tapar el pie */
      var cercaDelFinal = (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 240);
      var visible = mostrar && !cercaDelFinal;
      barra.classList.toggle('ky-visible-barra', visible);
      /* Sube el boton de WhatsApp para que no lo tape la barra */
      document.body.classList.toggle('ky-barra-abierta', visible);
    }

    var pendiente = false;
    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () { revisar(); pendiente = false; });
    }, { passive: true });
    revisar();
  }

  /* --- Test de piel -------------------------------------------------------- */
  function initQuiz() {
    var quiz = document.querySelector('[data-ky-quiz]');
    if (!quiz || quiz.dataset.kyListo === '1') return;
    quiz.dataset.kyListo = '1';

    var intro = quiz.querySelector('[data-ky-quiz-intro]');
    var juego = quiz.querySelector('[data-ky-quiz-juego]');
    var resultado = quiz.querySelector('[data-ky-quiz-resultado]');
    var prudente = quiz.querySelector('[data-ky-quiz-prudente]');
    var reiniciar = quiz.querySelector('[data-ky-quiz-reiniciar]');
    var barra = quiz.querySelector('[data-ky-quiz-barra]');
    var relleno = quiz.querySelector('[data-ky-quiz-barra-relleno]');
    var contador = quiz.querySelector('[data-ky-quiz-contador]');
    var atras = quiz.querySelector('[data-ky-quiz-atras]');
    var preguntas = [].slice.call(quiz.querySelectorAll('[data-ky-quiz-pregunta]'));
    if (!intro || !juego || !preguntas.length) return;

    var actual = 0;
    var pesos = [];

    function mostrar(el, si) {
      if (!el) return;
      if (si) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    }

    function pintar() {
      preguntas.forEach(function (p, i) { mostrar(p, i === actual); });
      var pct = Math.round(((actual) / preguntas.length) * 100);
      if (relleno) relleno.style.width = pct + '%';
      if (barra) barra.setAttribute('aria-valuenow', pct);
      if (contador) contador.textContent = 'Pregunta ' + (actual + 1) + ' de ' + preguntas.length;
      if (atras) atras.style.visibility = actual === 0 ? 'hidden' : 'visible';
    }

    function terminar() {
      var total = pesos.reduce(function (a, b) { return a + b; }, 0);
      var maximo = preguntas.length * 2;
      /* Por debajo del 45% del máximo, o con alguna respuesta de peso 0 en las
         dos primeras preguntas (piel sensible / irritación), vamos por la vía
         prudente y no forzamos la venta. */
      var sensible = (pesos[0] === 0) || (pesos[1] === 0) || (pesos[2] === 0);
      var encaja = (total >= maximo * 0.45) && !sensible;

      mostrar(juego, false);
      if (relleno) relleno.style.width = '100%';
      mostrar(encaja ? resultado : prudente, true);
      mostrar(reiniciar, true);
      var destino = encaja ? resultado : prudente;
      if (destino && destino.scrollIntoView) {
        destino.scrollIntoView({ behavior: sinMovimiento ? 'auto' : 'smooth', block: 'center' });
      }
    }

    function elegir(boton, indicePregunta) {
      var caja = preguntas[indicePregunta];
      caja.querySelectorAll('[data-ky-quiz-opcion]').forEach(function (b) {
        b.classList.toggle('ky-elegida', b === boton);
      });
      pesos[indicePregunta] = parseInt(boton.dataset.kyPeso || '1', 10);

      setTimeout(function () {
        if (actual < preguntas.length - 1) { actual++; pintar(); }
        else { terminar(); }
      }, 220);
    }

    preguntas.forEach(function (caja, i) {
      caja.querySelectorAll('[data-ky-quiz-opcion]').forEach(function (b) {
        b.addEventListener('click', function () { elegir(b, i); });
      });
    });

    quiz.querySelectorAll('[data-ky-quiz-empezar]').forEach(function (b) {
      b.addEventListener('click', abrir);
    });

    function abrir() {
      mostrar(intro, false);
      mostrar(resultado, false);
      mostrar(prudente, false);
      mostrar(juego, true);
      actual = 0;
      pesos = [];
      preguntas.forEach(function (c) {
        c.querySelectorAll('.ky-elegida').forEach(function (b) { b.classList.remove('ky-elegida'); });
      });
      pintar();
      if (juego.scrollIntoView) {
        juego.scrollIntoView({ behavior: sinMovimiento ? 'auto' : 'smooth', block: 'center' });
      }
    }

    if (atras) {
      atras.addEventListener('click', function () {
        if (actual > 0) { actual--; pintar(); }
      });
    }
    if (reiniciar) {
      reiniciar.addEventListener('click', function () {
        mostrar(reiniciar, false);
        abrir();
      });
    }

    /* Cualquier botón de la página con data-ky-abre-quiz abre ESTE mismo test */
    document.querySelectorAll('[data-ky-abre-quiz]').forEach(function (b) {
      if (b.dataset.kyListo === '1') return;
      b.dataset.kyListo = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        abrir();
      });
    });

    pintar();
  }

  /* --- Tarjetas de oferta de la ficha -------------------------------------- */
  function initOfertas() {
    var caja = document.querySelector('[data-ky-ofertas]');
    if (!caja || caja.dataset.kyListo === '1') return;
    caja.dataset.kyListo = '1';

    var form = caja.closest('form');
    var radios = caja.querySelectorAll('input[name="ky-oferta"]');
    var boton = form ? form.querySelector('button[type="submit"][name="add"]') : null;

    function refrescar() {
      caja.querySelectorAll('[data-ky-oferta]').forEach(function (tarjeta) {
        var radio = tarjeta.querySelector('input[name="ky-oferta"]');
        tarjeta.classList.toggle('ky-elegida', radio && radio.checked);
      });
    }

    radios.forEach(function (r) { r.addEventListener('change', refrescar); });
    refrescar();

    /* El botón de compra añade lo que diga la tarjeta elegida. */
    if (form && boton) {
      form.addEventListener('submit', function (e) {
        var elegido = caja.querySelector('input[name="ky-oferta"]:checked');
        if (!elegido) return;
        var items;
        try { items = JSON.parse(elegido.dataset.kyOfertaItems); } catch (err) { return; }
        if (!items || items.length < 2 && elegido.value === 'individual') return; /* individual: flujo normal */

        e.preventDefault();
        var textoOriginal = boton.textContent;
        boton.disabled = true;
        boton.textContent = 'Añadiendo…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function () { return kyLeerCarrito(); })
          .then(function () {
            boton.disabled = false;
            boton.textContent = textoOriginal;
            kyRefrescarCajon();
            var cajon = document.querySelector('cart-drawer');
            if (cajon && typeof cajon.open === 'function') {
              setTimeout(function () { cajon.open(); }, 250);
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function () {
            boton.disabled = false;
            boton.textContent = textoOriginal;
          });
      });
    }
  }

  /* --- Completa tu rutina: progreso X/4 y alta sin recargar ---------------- */
  var kyCarritoCache = null;

  function kyLeerCarrito() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { kyCarritoCache = c; return c; });
  }

  function kyRefrescarCajon() {
    /* Pide a Dawn que repinte el cajón del carrito sin recargar la página. */
    var cajon = document.querySelector('cart-drawer');
    if (cajon && typeof cajon.renderContents === 'function') {
      fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (s) {
          cajon.renderContents({
            sections: s,
            sections_url: window.location.pathname
          });
        })
        .catch(function () {});
      return;
    }
    var burbuja = document.getElementById('cart-icon-bubble');
    if (burbuja) {
      fetch('/?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (s) {
          if (s['cart-icon-bubble']) {
            var tmp = document.createElement('div');
            tmp.innerHTML = s['cart-icon-bubble'];
            var nuevo = tmp.querySelector('#cart-icon-bubble');
            if (nuevo) burbuja.innerHTML = nuevo.innerHTML;
          }
        })
        .catch(function () {});
    }
  }

  function initCompletaRutina() {
    var cajas = document.querySelectorAll('[data-ky-completa]');
    if (!cajas.length) return;

    function pintar(caja, carrito) {
      var total = parseInt(caja.dataset.kyTotal || '4', 10);
      var kitPrecio = parseInt(caja.dataset.kyKitPrecio || '0', 10);
      var kitVariante = caja.dataset.kyKitVariante;

      var enCarrito = {};
      var llevaKit = false;
      var sumaPasos = 0;
      (carrito.items || []).forEach(function (i) {
        if (String(i.variant_id) === String(kitVariante)) { llevaKit = true; return; }
        enCarrito[i.handle] = true;
      });

      var distintos = 0;
      caja.querySelectorAll('[data-ky-cc]').forEach(function (card) {
        var dentro = !!enCarrito[card.dataset.kyCc];
        card.classList.toggle('ky-cc--dentro', dentro);
        var btn = card.querySelector('[data-ky-cc-add]');
        var txt = card.querySelector('.ky-cc__btn-txt');
        if (btn) btn.disabled = dentro;
        if (txt) txt.textContent = dentro ? '✓ Añadido' : '+ Agregar';
        if (dentro) {
          distintos++;
          sumaPasos += parseInt(card.dataset.kyCcPrecio || '0', 10);
        }
      });

      caja.querySelectorAll('[data-ky-completa-punto]').forEach(function (punto, i) {
        punto.classList.toggle('ky-lleno', i < distintos);
      });

      var contador = caja.querySelector('[data-ky-completa-contador]');
      if (contador) contador.textContent = distintos + '/' + total;

      var estado = caja.querySelector('[data-ky-completa-estado]');
      if (estado) {
        if (llevaKit) {
          estado.textContent = 'Ya tienes la rutina completa en el carrito.';
          estado.className = 'ky-completa__estado ky-completa__estado--ok';
        } else if (distintos >= 4) {
          estado.textContent = '';
          estado.className = 'ky-completa__estado';
        } else if (distintos === 3) {
          estado.textContent = '15% OFF desbloqueado';
          estado.className = 'ky-completa__estado ky-completa__estado--ok';
        } else if (distintos === 2) {
          estado.textContent = '10% OFF desbloqueado · añade un tercero para el 15%';
          estado.className = 'ky-completa__estado ky-completa__estado--ok';
        } else if (distintos === 1) {
          estado.textContent = 'Añade un segundo paso y desbloqueas 10% OFF';
          estado.className = 'ky-completa__estado';
        } else {
          estado.textContent = 'Compra 2 pasos → 10% OFF · 3 pasos → 15% OFF';
          estado.className = 'ky-completa__estado';
        }
      }

      /* Con los 4 sueltos, comparamos de verdad: 15% sobre la suma vs. el kit. */
      var panelKit = caja.querySelector('[data-ky-completa-kit]');
      if (panelKit) {
        var sueltosConDto = Math.round(sumaPasos * 0.85);
        var conviene = distintos >= 4 && !llevaKit && kitPrecio > 0 && kitPrecio < sueltosConDto;
        if (conviene) { panelKit.removeAttribute('hidden'); } else { panelKit.setAttribute('hidden', ''); }
      }
    }

    function pintarTodas(carrito) {
      cajas.forEach(function (c) { pintar(c, carrito); });
    }

    cajas.forEach(function (caja) { caja.dataset.kyListo = '1'; });
    kyEngancharBotonesAdd(pintarTodas);
    kyLeerCarrito().then(pintarTodas).catch(function () {});
  }

  /* Engancha TODOS los "+ Agregar" de la página: los del bloque de la ficha y
     los que Dawn repinta dentro del cajón del carrito. */
  function kyEngancharBotonesAdd(despues) {
    document.querySelectorAll('[data-ky-cc-add]').forEach(function (btn) {
      if (btn.dataset.kyListo === '1') return;
      btn.dataset.kyListo = '1';
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var txt = btn.querySelector('.ky-cc__btn-txt');
        btn.disabled = true;
        if (txt) txt.textContent = 'Añadiendo…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: btn.dataset.kyCcAdd, quantity: 1 }] })
        })
          .then(function () { return kyLeerCarrito(); })
          .then(function (c) {
            if (typeof despues === 'function') despues(c);
            var card = btn.closest('[data-ky-cc]');
            if (card) {
              card.classList.add('ky-cc--pulso');
              setTimeout(function () { card.classList.remove('ky-cc--pulso'); }, 600);
            }
            if (txt) txt.textContent = '✓ Añadido';
            kyRefrescarCajon();
          })
          .catch(function () {
            btn.disabled = false;
            if (txt) txt.textContent = '+ Agregar';
          });
      });
    });
  }

  /* --- Message match de la landing: ?hook=a|b|c|d -------------------------- */
  function initHook() {
    var seccion = document.querySelector('[data-ky-hook-defecto]');
    if (!seccion || seccion.dataset.kyListo === '1') return;
    seccion.dataset.kyListo = '1';

    var pedido = (new URLSearchParams(window.location.search).get('hook') || '')
      .trim().toLowerCase();
    if (!pedido) return;

    var opciones = seccion.querySelectorAll('[data-ky-hook]');
    var existe = false;
    opciones.forEach(function (o) {
      if (o.dataset.kyHook.trim().toLowerCase() === pedido) existe = true;
    });
    if (!existe) return;

    opciones.forEach(function (o) {
      var suyo = o.dataset.kyHook.trim().toLowerCase() === pedido;
      if (suyo) { o.removeAttribute('hidden'); } else { o.setAttribute('hidden', ''); }
    });
  }

  function iniciarTodo() {
    initHook();
    initOfertas();
    initCompletaRutina();
    kyEngancharBotonesAdd();
    initQuiz();
    initBarraCompra();
    initReveals();
    initContadores();
    initAcordeones();
    initGaleria();
    initVariantes();
    initComparador();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  } else {
    iniciarTodo();
  }

  /* El editor de Shopify recarga secciones sueltas: re-inicializa. */
  document.addEventListener('shopify:section:load', iniciarTodo);

  /* Dawn repinta el cajón del carrito: hay que reenganchar sus botones. */
  var observador = new MutationObserver(function () { kyEngancharBotonesAdd(); });
  document.addEventListener('DOMContentLoaded', function () {
    var cajon = document.querySelector('cart-drawer, #CartDrawer, cart-notification');
    if (cajon) observador.observe(cajon, { childList: true, subtree: true });
  });
})();
